<template>
    <div class="coupons-container">
        <div class="list" v-for="(item, index) in list" :key="index">
            <div class="cell-conetnt">
                <div
                    class="imgIcon"
                    @click="imageAlbum(item)"
                    :style="{ backgroundImage: `url(${item.smallImg})` }"
                >
                    <div class="award-ready" v-if="item.awardStatus === 20"></div>
                </div>
                <div class="cell-con">
                    <div class="title">
                        {{ item.awardName }}
                    </div>
                    <div class="desc">
                        {{ item.simpleDesc }}
                    </div>
                    <div
                        class="btn-new"
                        :class="getClassForBtn(item)"
                        @click="add2ShoppingCar(item)"
                    >
                        {{ itemBtnDesc(item) }}
                    </div>
                </div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
    name: 'upgrade-list',
    props: {
        list: {
            type: Array,
            default: []
        },
        limitCount: {
            type: Number,
            default: 3
        },
        content: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            selectItem: [],
            selected: null
        };
    },
    methods: {
        ...mapMutations('home', ['setSelectedGift']),
        add2ShoppingCar(item) {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包实物详情',
                page: 'super-升级礼包实物详情',
                param1: `${this.content.score}`,
                param2: `${this.content.requiredScore}`,
                param3: `${this.itemBtnDesc(item)}`,
                param4: `${item.awardName}`
            });
            if (item.awardStatus === 20) {
                this.$emit('orderIdDialog', item);
                return;
            }
            if (this.selectItem.length >= this.limitCount) {
                if (`${this.selectItem.indexOf(item.awardKey)}` == -1) {
                    this.$toast('已达领取上限');
                    return;
                }
            }
            if (this.selectItem.indexOf(item.awardKey) === -1) {
                this.selectItem.push(item.awardKey);
            } else {
                this.selectItem = this.selectItem.filter(e => e !== item.awardKey);
            }
            this.setSelectedGift(item);
            this.$emit('currentSelected', this.selectItem);
        },
        imageAlbum(item) {
            this.$emit('imageAlbum', item);
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包实物详情',
                page: 'super-升级礼包实物详情',
                param1: `${this.content.score}`,
                param2: `${this.content.requiredScore}`,
                param3: `商品大图`,
                param4: `${item.awardName}`
            });
        },

        isShowBtn(item) {
            if (
                (this.limitCount === 0 || !this.content.isReachedPageScore) &&
                item.awardStatus !== 20
            ) {
                return false;
            } else {
                return true;
            }
        },
        itemBtnDesc(item) {
            if (item.awardStatus === 0) {
                if (this.content.requiredScore > this.content.score) {
                    return `还差${this.content.requiredScore - this.content.score}活力值可领`;
                }
                if (this.content.availableQuantity === 0) {
                    return '权益已使用';
                }
            }
            if (item.awardStatus === 20) {
                return '查看物流';
            }
            return '立即领取';
        },
        getClassForBtn(item) {
            if (item.awardStatus === 0) {
                if (this.content.requiredScore > this.content.score) {
                    return 'btn-new_used';
                }
                if (this.content.availableQuantity === 0) {
                    return 'btn-new_used';
                }
            }
            if (item.awardStatus === 20) {
                return 'btn-new_check-express';
            } else {
                return 'btn-new_available';
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.coupons-container {
    margin: auto;
    height: 100%;
    overflow: hidden;
    margin-left: 19px;
    margin-right: 19px;
    padding-bottom: 70px;
    padding-top: 10px;
    .list {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        .cell-conetnt {
            display: flex;
            flex-direction: row;
            .imgIcon {
                width: 84px;
                height: 84px;
                background-size: 100% 100%;
                border-radius: 4px;
                border: 0.5px solid #f5f5f5;
                display: flex;
                flex-direction: row;
                .award-ready {
                    .backgroundImage(44px, 44px, '~@assets/img/award_ready.png');
                    background-size: 100% 100%;
                    margin-left: 44px;
                }
            }
            .cell-con {
                display: flex;
                flex-direction: column;
                margin-left: 18px;
                .title {
                    .f-14-bold();
                    color: #292738;
                }
                .desc {
                    .f-12-bold();
                    margin-top: 9px;
                    color: #9faab5;
                    line-height: 18px;
                }
                .btn-new {
                    height: 26px;
                    width: fit-content;
                    padding: 0 8px;
                    border-radius: 2px;
                    line-height: 27px;
                    text-align: center;
                    font-size: 12px;
                    font-family: fzlt_bold;
                    font-weight: normal;
                    margin-top: 15px;
                    &_available {
                        background: #3ca5e2;
                        color: #fff;
                    }
                    &_check-express {
                        color: #3ca5e2;
                        border: 1px solid #3ca5e2;
                    }
                    &_used {
                        background: #dce1e6;
                        color: #fff;
                    }
                }
            }
        }
        .line {
            width: 335px;
            height: 1px;
            background-color: #e4e4e4;
            transform: scaleY(0.5);
            margin-top: 20px;
        }

        .btn {
            // position: absolute;
            top: 27px;
            right: 0px;
            width: 78px;
            height: 28px;
            background: rgba(255, 255, 255, 1);
            border-radius: 15px;
            border: 1px solid rgba(199, 146, 38, 1);
            color: #c79226;
            .f-12-bold();
            text-align: center;
            line-height: 30px;
            margin-bottom: 19px;
            margin-top: 19px;
        }
    }
}
</style>
